import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="font-heading text-2xl font-bold text-background-50 whitespace-nowrap">
              51黑料
            </Link>
            <p className="mt-3 text-sm text-secondary-300 leading-relaxed">
              专注收录互联网热门黑料、爆料内容的聚合平台，汇聚娱乐圈、网红、明星最新黑料资讯，实时更新，一键直达全网最劲爆内容。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">快速链接</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-secondary-300 hover:text-background-50 transition-colors whitespace-nowrap">首页</Link></li>
              <li><Link to="/category/zuixin" className="text-sm text-secondary-300 hover:text-background-50 transition-colors whitespace-nowrap">最新爆料</Link></li>
              <li><Link to="/about" className="text-sm text-secondary-300 hover:text-background-50 transition-colors whitespace-nowrap">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">热门分类</h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-secondary-300 hover:text-background-50 transition-colors whitespace-nowrap">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">联系我们</h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-secondary-300">
                <i className="ri-mail-line"></i>
                <span>contact@51heiliao.com</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-secondary-300">
                <i className="ri-wechat-line"></i>
                <span>51heiliao_official</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-secondary-300">
                <i className="ri-weibo-line"></i>
                <span>@51黑料官方</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-secondary-700/50">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-secondary-400">
            &copy; {new Date().getFullYear()} 51黑料 - 最新热门黑料爆料聚合平台. 版权所有.
          </p>
          <div className="flex items-center gap-4 text-xs text-secondary-400">
            <a href="#" className="hover:text-background-50 transition-colors whitespace-nowrap">隐私政策</a>
            <a href="#" className="hover:text-background-50 transition-colors whitespace-nowrap">服务条款</a>
            <a href="#" className="hover:text-background-50 transition-colors whitespace-nowrap">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}